const FORBIDDEN_KEYS = new Set([
  'access',
  'refresh',
  'authorization',
  'password',
  'token',
  'userinfo',
  'userInfo',
  'cookie',
  'cookies',
  'sessionid',
  'secret',
  'body',
  'payload',
  'email',
  'phone',
  'phone_number',
  'description',
]);

const JWT_PATTERN = /eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*/g;
const BEARER_PATTERN = /Bearer\s+\S+/gi;
const WS_TOKEN_URL_PATTERN = /(token=)[^&\s"']+/gi;

export const REDACTED = '[REDACTED]';

/**
 * @param {string} value
 * @returns {string}
 */
export function redactString(value) {
  if (typeof value !== 'string' || !value) {
    return value;
  }
  return value
    .replace(BEARER_PATTERN, 'Bearer [REDACTED]')
    .replace(JWT_PATTERN, REDACTED)
    .replace(WS_TOKEN_URL_PATTERN, '$1[REDACTED]');
}

/**
 * @param {unknown} value
 * @returns {unknown}
 */
export function redactValue(value) {
  if (value == null || typeof value === 'boolean' || typeof value === 'number') {
    return value;
  }
  if (typeof value === 'string') {
    return redactString(value);
  }
  if (Array.isArray(value)) {
    return value.map(redactValue);
  }
  if (typeof value === 'object') {
    return redactObject(value);
  }
  return REDACTED;
}

/**
 * @param {Record<string, unknown>} object
 * @returns {Record<string, unknown>}
 */
export function redactObject(object) {
  const redacted = {};
  Object.entries(object).forEach(([key, value]) => {
    if (FORBIDDEN_KEYS.has(key)) {
      redacted[key] = REDACTED;
      return;
    }
    redacted[key] = redactValue(value);
  });
  return redacted;
}

/**
 * @param {string} stack
 * @returns {string}
 */
export function safeComponentStack(stack) {
  if (typeof stack !== 'string' || !stack) {
    return '';
  }
  const lines = stack.split('\n').slice(0, 8);
  return redactString(lines.join('\n'));
}
